import { useForm } from 'react-hook-form';
import { useSearchParams } from 'react-router-dom';
import { yupResolver } from '@hookform/resolvers/yup';
import { SEARCH_PARAMS } from 'constants/dataSets';
import {
  ORDER_KEY, ORDER_TYPE, RELATE_TO, RELATE_TO_MA, SEARCH, SORT,
  STATUS,
} from 'constants/formFields';
import { ORDERS } from 'constants/interfaces';
import { dataTaskListSchema } from 'utils/validators';

import type { TDataTaskListSchema } from 'utils/validators';

const useTaskListForm = () => {
  const [searchParams] = useSearchParams();
  const searchParam = searchParams.get(SEARCH_PARAMS.search) || '';

  const {
    control,
    handleSubmit,
    getValues,
    setValue,
    watch,
  } = useForm<TDataTaskListSchema>({
    mode: 'onChange',
    resolver: yupResolver(dataTaskListSchema),
    defaultValues: {
      [SEARCH]: searchParam,
      [SORT]: {
        [ORDER_KEY]: '',
        [ORDER_TYPE]: ORDERS.asc,
      },
      [RELATE_TO]: [],
      [RELATE_TO_MA]: [],
      [STATUS]: [],
    },
  });

  return {
    control,
    handleSubmit,
    getValues,
    setValue,
    watch,
  };
};

export default useTaskListForm;
